'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFitnessSettings = exports.disconnectFitness = exports.connectFitness = exports.fetchPageFitness = exports.allowedActivityTypes = undefined;

var _capitalize = require('lodash/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

var _client = require('../../utils/client');

var _base = require('../../utils/base64');

var _params = require('../../utils/params');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allowedActivityTypes = exports.allowedActivityTypes = ['hike', 'ride', 'run', 'swim', 'walk', 'wheelchair'];

var fetchPageFitness = exports.fetchPageFitness = function fetchPageFitness(_ref) {
  var _ref$slug = _ref.slug,
      slug = _ref$slug === undefined ? (0, _params.required)() : _ref$slug,
      _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 100 : _ref$limit,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  var params = { limit: limit, offset: offset, start: startDate, end: endDate };
  return (0, _client.get)('/v1/fitness/fundraising/' + slug, params);
};

var connectFitness = exports.connectFitness = function connectFitness(_ref2) {
  var _ref2$code = _ref2.code,
      code = _ref2$code === undefined ? (0, _params.required)() : _ref2$code,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      _ref2$scope = _ref2.scope,
      scope = _ref2$scope === undefined ? 'read,activity:read' : _ref2$scope,
      _ref2$provider = _ref2.provider,
      provider = _ref2$provider === undefined ? 'strava' : _ref2$provider;

  var query = '\n    mutation {\n      ' + (provider === 'fitbit' ? 'connectFitbit' : 'connectFitness') + ' (\n        input: {\n          code: "' + code + '"\n          scope: "' + scope + '"\n        }\n      )\n    }\n  ';

  var headers = { Authorization: 'Bearer ' + token };

  return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }, { headers: headers }).then(function (response) {
    return response.data;
  });
};

var disconnectFitness = exports.disconnectFitness = function disconnectFitness(_ref3) {
  var _ref3$pageId = _ref3.pageId,
      pageId = _ref3$pageId === undefined ? (0, _params.required)() : _ref3$pageId,
      _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token,
      _ref3$provider = _ref3.provider,
      provider = _ref3$provider === undefined ? 'Strava' : _ref3$provider;

  var query = '\n    mutation {\n      setFitnessApplicationSettings(\n        input: {\n          pageId: "' + (0, _base.encodeBase64String)('Page:FUNDRAISING:' + pageId) + '",\n          name: "' + (0, _capitalize2.default)(provider) + '",\n          subscribedActivities: []\n        }\n      ) {\n        subscribedActivities\n      }\n    }\n  ';

  var headers = { Authorization: 'Bearer ' + token };

  return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }, { headers: headers }).then(function (response) {
    return response.data;
  });
};

var updateFitnessSettings = exports.updateFitnessSettings = function updateFitnessSettings(_ref4) {
  var _ref4$pageId = _ref4.pageId,
      pageId = _ref4$pageId === undefined ? (0, _params.required)() : _ref4$pageId,
      _ref4$token = _ref4.token,
      token = _ref4$token === undefined ? (0, _params.required)() : _ref4$token,
      _ref4$provider = _ref4.provider,
      provider = _ref4$provider === undefined ? 'Strava' : _ref4$provider,
      _ref4$measurementSyst = _ref4.measurementSystem,
      measurementSystem = _ref4$measurementSyst === undefined ? 'METRIC' : _ref4$measurementSyst,
      _ref4$subscribedActiv = _ref4.subscribedActivities,
      subscribedActivities = _ref4$subscribedActiv === undefined ? allowedActivityTypes : _ref4$subscribedActiv,
      _ref4$showDistance = _ref4.showDistance,
      showDistance = _ref4$showDistance === undefined ? true : _ref4$showDistance,
      _ref4$showDuration = _ref4.showDuration,
      showDuration = _ref4$showDuration === undefined ? true : _ref4$showDuration,
      _ref4$showElevation = _ref4.showElevation,
      showElevation = _ref4$showElevation === undefined ? true : _ref4$showElevation,
      _ref4$showPhotos = _ref4.showPhotos,
      showPhotos = _ref4$showPhotos === undefined ? false : _ref4$showPhotos,
      _ref4$showMap = _ref4.showMap,
      showMap = _ref4$showMap === undefined ? false : _ref4$showMap,
      _ref4$showTotaliser = _ref4.showTotaliser,
      showTotaliser = _ref4$showTotaliser === undefined ? true : _ref4$showTotaliser;

  var filteredActivityTypes = subscribedActivities.filter(function (type) {
    return allowedActivityTypes.indexOf(type.toLowerCase()) > -1;
  }).map(function (type) {
    return type.toUpperCase();
  });

  var query = '\n    mutation {\n      setFitnessApplicationSettings(\n        input: {\n          pageId: "' + (0, _base.encodeBase64String)('Page:FUNDRAISING:' + pageId) + '",\n          name: "' + (0, _capitalize2.default)(provider) + '",\n          measurementSystem: ' + measurementSystem.toUpperCase() + '\n          subscribedActivities: [' + filteredActivityTypes + ']\n          showDistance: ' + showDistance + '\n          showDuration: ' + showDuration + '\n          showElevation: ' + showElevation + '\n          showPhotos: ' + showPhotos + '\n          showMap: ' + showMap + '\n          showTotaliser: ' + showTotaliser + '\n        }\n      ) {\n        measurementSystem\n        subscribedActivities\n        showDistance\n        showDuration\n        showElevation\n        showPhotos\n        showMap\n        showTotaliser\n      }\n    }\n  ';

  var headers = { Authorization: 'Bearer ' + token };

  return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }, { headers: headers }).then(function (response) {
    return response.data;
  });
};